module.exports = __webpack_public_path__ + "img/delivering.6a40a397.svg";